// @ts-nocheck
/* eslint-disable */
export const blendIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 25 24"><g fill="#F6C657"><path d="M22.38 12a6.005 6.005 0 0 1-8.118 5.614c-.319-.121-.378-.529-.157-.788A7.4 7.4 0 0 0 15.881 12a7.4 7.4 0 0 0-1.773-4.825c-.222-.26-.163-.669.156-.79A6.005 6.005 0 0 1 22.38 12"/><path d="M14.38 12c0 1.77-.77 3.37-2 4.46a5.93 5.93 0 0 1-4 1.54c-3.31 0-6-2.69-6-6s2.69-6 6-6c1.54 0 2.94.58 4 1.54 1.23 1.09 2 2.69 2 4.46"/></g></svg>`,
    name: 'blend' as const
};